import './Inicio.css';
import React, { useState, useEffect, useCallback } from 'react';
import regr from '../Componentes/regr.png';
import axios from 'axios';
import Logoicono from '../Componentes/logosvg2';
import Asignar from '../Componentes/Asingar';
import { useLocation, useNavigate} from 'react-router-dom';
import { useContext } from 'react';
import { DataContext } from '../Componentes/DataContext';
import DatePicker from 'react-datepicker';
import Calendario from '../Icons/calend.png';

function Inicio() {
  const [us, setUs] = useState({estado:'', id:'', nombre:'', tipo: '', idcancha:''});

const [diaSeleccionadoISO, setDiaSeleccionadoISO] = useState("");
const [diasISO, setDiasISO] = useState([]);

  const [horarios, setHorarios] = useState([]);
  const [NombreEstablecimiento, setNombreEstablecimiento] = useState('');
  const [horas, setHoras] = useState([]);
  const [manejoHoras, setManejoHoras] = useState({apertura:'', ciclo:''});
  const [canchastodas, setcanchastodas] = useState(['']);
  const [reservasObtenidas, setReservasObtenidas] = useState([]);
  const [allcansend, setAllcansen] = useState([]);
  const [canfut5, setCanfut5] = useState([]);
  const [canfut7, setCanfut7] = useState([]);
  const [canfut11, setCanfut11] = useState([]);
  const [reservasMap, SetreservasMap] = useState([]);
  const [ResInfo, setResInfo] = useState();
  const [existe,setExiste] = useState('false');
  const [paraasignar, setparaasignar] = useState([]);
  const { setOfertasData } = useContext(DataContext);

  axios.defaults.withCredentials = true;

    const [timer, setTimer] = useState(true);
  useEffect(() => {
      cargarDatos();
      generarDias();
  }, []);
  
  
  useEffect(()=>{
    const arreglo = [];
    for (let i = 0; i < manejoHoras.ciclo; i++) {
      arreglo.push((manejoHoras.apertura + i).toString()); // Convierte el número a string y lo agrega al arreglo
    };
    setHoras(arreglo);
  },[manejoHoras]);
  
  
                                                                        //Convertir datos segun su uso
useEffect(()=>{
    if (canchastodas.length > 0) {
      const arreglo1 = [];
      const arreglo2 = [];
      const arreglo3 = [];
      
      canchastodas.forEach(cancha => {
      if (cancha.tipo === 5) {
        arreglo1.push({nombre: (cancha.nombre).toString(), id: (cancha.id_cancha).toString(), Deposito: cancha.deposito, Precio: cancha.precio, Descripcion: cancha.descripcion, Tipo: cancha.tipo});
      }
      else if (cancha.tipo === 7){
        arreglo2.push({nombre: (cancha.nombre).toString(), id: (cancha.id_cancha).toString(), Deposito: cancha.deposito, Precio: cancha.precio, Descripcion: cancha.descripcion, Tipo: cancha.tipo});
      }
      else if (cancha.tipo === 11){
        arreglo3.push({nombre: (cancha.nombre).toString(), id: (cancha.id_cancha).toString(), Deposito: cancha.deposito, Precio: cancha.precio, Descripcion: cancha.descripcion, Tipo: cancha.tipo});
      }})
      const arreglo4 = {fut5: arreglo1, fut7: arreglo2, fut11: arreglo3};

    setCanfut5(arreglo1);
    setCanfut7(arreglo2);
    setCanfut11(arreglo3);
    setOfertasData(arreglo4);
    sessionStorage.setItem('ofertasArray', JSON.stringify(arreglo4));
    
    }
},[canchastodas])
  
  
useEffect(() => {

  const dia = diaSeleccionado.split(',')[0];
  console.log(diaSeleccionado);
  
    if (horarios.length > 0) {
      horarios.forEach((user) =>{
        setNombreEstablecimiento(user.Nombre_establecimiento);
        let apertura, cierre,ciclo;
        switch (dia) {
          case 'lunes':
            apertura = Number(String(user.LunesApertura).substr(0,2));
            cierre = Number(String(user.LunesCierre).substr(0,2));
          break;
          case 'martes':
            apertura = Number(String(user.MartesApertura).substr(0,2));
            cierre = Number(String(user.MartesCierre).substr(0,2));
          break;
          case 'miércoles':
            apertura = Number(String(user.MiercolesApertura).substr(0,2));
            cierre = Number(String(user.MiercolesCierre).substr(0,2));
          break;
          case 'jueves':
            apertura = Number(String(user.JuevesApertura).substr(0,2));
            cierre = Number(String(user.JuevesCierre).substr(0,2));
          break;
          case 'viernes':
            apertura = Number(String(user.ViernesApertura).substr(0,2));
            cierre = Number(String(user.ViernesCierre).substr(0,2));
          break;
          case 'sábado':
            apertura = Number(String(user.SabadoApertura).substr(0,2));
            cierre = Number(String(user.SabadoCierre).substr(0,2));
          break;
          case 'domingo':
            apertura = Number(String(user.DomingoApertura).substr(0,2));
            cierre = Number(String(user.DomingoCierre).substr(0,2));
          break;
          default:
            break;
        }
        if (cierre === 0) cierre = 24;
        // Si la hora de cierre es menor que la de apertura, significa que pasa de medianoche
        if (cierre < apertura) {
            ciclo = (24 - apertura) + cierre; // Calcula el ciclo pasando por medianoche
        } else {
            ciclo = cierre - apertura; // Calcula el ciclo sin pasar por medianoche
        }
        setManejoHoras({apertura, ciclo})
      });
    }
  }, [horarios, diaSeleccionadoISO]);

  useEffect(()=>{
    getReservas();
  },[diaSeleccionadoISO])

  const diaForm2 = (date) => {
  const d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
      .toISOString()
      .split("T")[0];
  };

  // For LOCAL dates (from generarDias)
const diaFormateadoLocal = (date) => {
  return date.toLocaleDateString('es-GT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

// For ISO strings (from diasISO.map)
const diaFormateadoISO = (isoString) => {
  const [year, month, day] = isoString.split('-');
  const localDate = new Date(year, month - 1, day); // Parse as LOCAL time
  return localDate.toLocaleDateString('es-GT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};
                                                                    // Cambiar Dias
const generarDias = () => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0); // Local midnight (GMT-6)
  const arregloDias = [];
  const arregloDiasISO = [];

  for (let i = 0; i < 8; i++) {
    const fecha = new Date(hoy);
    fecha.setDate(hoy.getDate() + i); // Add 'i' days (LOCAL TIME)
    
    // Store LOCAL date (no UTC conversion)
    arregloDias.push(diaFormateadoLocal(fecha)); // Use local formatter
    arregloDiasISO.push(fecha.toISOString().split('T')[0]); // Optional: Still UTC, but handled later
  }
  setDiasISO(arregloDiasISO);
  setDiaSeleccionadoISO(arregloDiasISO[0]);
};

// Derived values
const diaSeleccionado = diaFormateadoISO(diaSeleccionadoISO);
const diasdisponibles = diasISO.map(iso => diaFormateadoISO(iso));

const manejarCambio = (event) => {
  const selectedDisplayDate = event.target.value;
  const selectedIndex = diasdisponibles.findIndex(
    dia => dia === selectedDisplayDate
  );
  if (selectedIndex !== -1) {
    setDiaSeleccionadoISO(diasISO[selectedIndex]); 
  }
  setIsOpen(false);
};

const location = useLocation();
const data = location.state;
const navigate = useNavigate();

useEffect(()=>{
    if (location.state?.from === 'notific'){
      console.log(data.msg.dia);
      if (diasdisponibles.length > 0){
        pruebanot(data.msg.dia);
        navigate('/', {state:{from: 'ready'}});
      }
    }
    if (location.state?.from === 'any'){
      if (diasdisponibles.length > 0){
        pruebanot(0);
        navigate('/', {state:{from: 'ready'}});
      }
    }
    else {return}
  }, [location.state?.from === 'ready', diasdisponibles]);


const pruebanot = (indnot) => {
  console.log(indnot);
  setDiaSeleccionadoISO(diasISO[indnot]);
  setIsOpen(false);
};

const diamas = () => {
  const currentIndex = diasISO.indexOf(diaSeleccionadoISO);
  if (currentIndex < diasISO.length - 1 && currentIndex >= 0) {
    setDiaSeleccionadoISO(diasISO[currentIndex + 1]);
  } else if (currentIndex === -1){
    setDiaSeleccionadoISO(diasISO[7]);
  }
};

const diamenos = () => {
  const currentIndex = diasISO.indexOf(diaSeleccionadoISO);
  console.log('diamenos: ',currentIndex);
  if (currentIndex > 0) {
    setDiaSeleccionadoISO(diasISO[currentIndex - 1]);
  } else if (currentIndex === -1){
    setDiaSeleccionadoISO(diasISO[0]);
  }
};
                                                                  //Abrir informacion de cada dia
  const [isOpen, setIsOpen] = useState(false);
  const [tipocancha, setTipocancha] = useState(false);
  const [conscancha, setConscancha] = useState(false);
  const [horacancha, setHoracancha] = useState(false);
   
  const clickasignar = (hora, dia)  => {
    const arreglodatos = [];
    reservasObtenidas.forEach(reserva => {
      switch (reserva.estado) {
        case 'Pendiente':
          if (Number(reserva.hora.split(':')[0]) === Number(hora) && reserva.dia.split('T')[0] === dia){
            arreglodatos.push(reserva);}
          break;
        default:
          break;
      }
    });
    if (arreglodatos.length > 0){
      setIsOpen(true);
      setExiste('asignar');
      setHoracancha(hora);
      setparaasignar(arreglodatos);
    }
  }
  const NombreEnCelda = (id, hora, dia) => {
    const reserva = reservasMap[`${id}_${hora}_${dia}`];
    if (!reserva) { // Si no hay reserva
      return '';
    };
      return reserva.Nombre_cliente.split(' ')[0];
  };

  const [othInfo, setOthinfo] = useState('');
  const clickDisponibilidad = (id, hora, dia, nombre, tipo, othinfo) => {
    
    const reserva = reservasMap[`${id}_${hora}_${dia}`];
    setIsOpen(true);    
    if (!reserva) { // Si no hay reserva
      setExiste('false');
      setHoracancha(hora);
      setTipocancha(tipo);
      setConscancha(nombre);
      return
    }
    else{
      setExiste('true');
      setResInfo(reserva);
      setTipocancha(tipo);
      setHoracancha(hora);
      setOthinfo(othinfo);
      setConscancha(nombre);
      if (reserva.estado === 'Dependiente'){
        setExiste('soloinfo');
      }
    }
  };
  
                                                                    //Consultas SQL
  async function cargarDatos() {
    try {
      await Promise.all([
        getHorarios(),
        getCanchas(),
        getReservas()
      ]);
      console.log("Todas las consultas se han completado.");
    } catch (error) {
      console.error("Error al cargar datos:", error);
    } finally {
      setTimer(false); // Desactiva la animación de carga
    }
  }

  // Función para obtener horarios
  function getHorarios() {
    return new Promise(resolve => {
      axios
      .get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/horarios`)
      .then((response) => {
        setHorarios(response.data);
        resolve (true);
      })
      .catch((error) => {
        console.error("Error al obtener los Horarios:", error);
      });}
    )
  }
  // Función para obtener canchas
  function getCanchas() {
    return new Promise(resolve => {
      axios
      .get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/canchas`)
      .then((response) => {
        setcanchastodas(response.data);
        resolve (true);
      })
      .catch((error) => {
        console.error("Error al obtener las Canchas:", error);
      });
    })
  }

  // Función para obtener reservas
  function getReservas() {
    if (diaSeleccionadoISO.length > 0) {
      return new Promise (resolve => {
        axios
        .get(
          `${process.env.REACT_APP_HTTPS}/api/establecimientos/reservas?dia=${diaSeleccionadoISO}`
        )
        .then((response) => {
          setReservasObtenidas(response.data);
          resolve (true);
        })
        .catch((error) => {
          console.error("Error al obtener las Reservas:", error);
          window.location.reload();
        });
      })
    } else {
      return Promise.resolve(); // Si no hay un día seleccionado, no realiza la consulta
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      getReservas();
    }, 30000);
               // clearing interval
    return () => clearInterval(timer);
  }); 

  useEffect(() => {
    if (reservasObtenidas.length > 0) {
        const pres = (reservasObtenidas.reduce((acc, reserva) => {
      const key = `${reserva.id_cancha}_${Number(reserva.hora.split(':')[0])}_${String(reserva.dia).split('T')[0]}`;
      acc[key] = reserva;
      return acc;
    }, {}));
    SetreservasMap(pres);
    } else {SetreservasMap([]);
    }
  },[reservasObtenidas]);
  
  const getClassName = useCallback((id, hora, dia) => {
    if (reservasObtenidas.length > 0) {
      const reserva = reservasMap[`${id}_${hora}_${dia}`];
      if (!reserva) {
        return null;
      } 
      else if (reserva.Medio === 'Manual') {
        return 'reservation-cell special';
      }
      else if (reserva.Medio === 'Especial') {
        return 'reservation-cell other';
      }
      else if (reserva.estado === 'Aprobada' & reserva.Medio==='App'){
        return 'reservation-cell';
      }
      else if (reserva.estado === 'Dependiente'){
        return 'reservation-cell2';
      }
      else if (reserva.estado === 'Pendiente'){
        return 'hour-cell';
      }
  }
  }, [reservasMap]);

  const asignardatos = (hacer, asignarinfo) => {    
    switch (hacer) {
      case 'asignar':
        setUs(hacer);
        setResInfo(asignarinfo);
        if (asignarinfo.tipo_cancha === 5) {setOthinfo(canfut5)}
        else if (asignarinfo.tipo_cancha === 7) {setOthinfo(canfut7)}
        else if (asignarinfo.tipo_cancha === 11) {setOthinfo(canfut11)}
        else {setOthinfo('Diablos')}
        break;
      case 'editar':
        setUs(hacer);
        setResInfo(asignarinfo);
        if (asignarinfo.tipo_cancha === 5) {setOthinfo(canfut5)}
        else if (asignarinfo.tipo_cancha === 7) {setOthinfo(canfut7)}
        else if (asignarinfo.tipo_cancha === 11) {setOthinfo(canfut11)}
        else {setOthinfo('Diablos')}
        break;
      case 'newreserva':
        setUs(hacer);
        setHoracancha('12');
        break;
      case 'borrar':
        setUs(hacer); 
        setResInfo(asignarinfo);
        break;
      case 'rechazar':
        setUs(hacer);
        setResInfo(asignarinfo);
        break;
      default:
        console.log('Estado invalido del PopUp');
        break;
    }
  }

  const closeasignar = () =>{
    setTimeout(() => {
    getReservas();
    setIsOpen(false);
    }, 1000);
    setUs({estado:'', id:'', nombre: '', tipo: ''});
  }
  const [opencalendar, setOpenCal] = useState(false);

  const satedatepicker = (date) => {
  const isoDate = diaForm2(date); // Convert to "YYYY-MM-DD"
  if (diasISO.includes(isoDate)) {
    setDiaSeleccionadoISO(isoDate); // Auto-updates derived values
  } else {
    setDiaSeleccionadoISO(isoDate);
    console.warn("Selected date is outside the 8-day range.");
  }
  setOpenCal(false);
};

    return (
      <div className='Inicio'>
        {timer ? (<div className='cargando'>
              <div className='logocargando'><Logoicono/></div>
            </div>):(
              <>  
        <div className='infocancha'>
          
          {isOpen ? (<div className='outnot' onClick={() => setIsOpen(false)}></div>):(<></>)}
          <div className={`sidebar ${isOpen ? 'active' : ''}`}>
          <div id='back-button' onClick={()=>setIsOpen(false)}><img src={regr} id="regresar" alt="Regresar"/></div>
          <div className='scrollphone'>
            {existe === 'false' ? (<><p className='infoinicial'>La <b>{conscancha}</b> de futbol {tipocancha} a las <b>{horacancha}:00</b> NO TIENE NINGUNA RESERVA ASIGNADA</p></>
            ): existe === 'true' ? (<>
            <p className='infoinicial'>La <b>{conscancha}</b> de futbol {ResInfo.tipo_cancha} a las <b>{horacancha}:00</b> pertenece a {ResInfo.Nombre_cliente.split(' ')[0]}.</p>
            <ul className='listainfocancha'>
              <li>Nombre: <b>{ResInfo.Nombre_cliente}</b></li>
              <li>Correo: <b>{ResInfo.correo}</b></li>
              <li>Contacto: <b>{ResInfo.contacto}</b></li>
              <li>Deposito: {othInfo.Deposito}</li>
              <li>Precio: {othInfo.Precio}</li>
              <li>Pagado: {ResInfo.pagado}</li>
            </ul><div className='infophone'><button className='btneditar' onClick={() => asignardatos('editar', ResInfo)}>Editar</button>
            <button className='btneditar' onClick={()=>asignardatos('borrar', ResInfo)}>Cancelar</button>
            </div>
            <ul className='listainfocancha'><li className='descripcioncan'>Comentario: {ResInfo.Descripcion}</li></ul>
            </>
            ): existe === 'asignar' ? (<>
            <h3>Tienes {Number(paraasignar.length)} solicitudes de reserva a las {horacancha}:00 horas</h3>
            <ul>
            {paraasignar.map((asignar,i,alldata)=>(<div key={i}>
                <li style={{listStyle: 'none'}}>{i+1}. El cliente <b>{asignar.Nombre_cliente}</b> solicita una cancha de futbol {asignar.tipo_cancha}.</li>
                <div className='infophoneasig'><button className='asignardatos' onClick={() => asignardatos('asignar', alldata[i])}>Asignar</button>
                <button className='asignardatos' onClick={() => asignardatos('rechazar', alldata[i])}>Rechazar</button></div>
              </div>
            ))}</ul>
            </>): existe === 'soloinfo' ? (<>
            <p className='infoinicial'>La <b>{conscancha}</b> de futbol {tipocancha} a las <b>{horacancha}:00</b> pertenece a {ResInfo.Nombre_cliente.split(' ')[0]}.</p>
            <ul className='listainfocancha'>
              <li>Nombre: <b>{ResInfo.Nombre_cliente}</b></li>
              <li>Correo: <b>{ResInfo.correo}</b></li>
              <li>Contacto: <b>{ResInfo.contacto}</b></li>
            </ul>
            <ul className='listainfocancha'><li className='descripcioncan'>Comentario: {ResInfo.Descripcion}</li></ul>
            </>
            ):(<></>)}</div>
          </div>
        </div>
        <div className="container">
              <Asignar us={us} diISO={diaSeleccionadoISO} di={diaSeleccionado} 
              ho={horacancha} arrf5={canfut5} arrf7={canfut7} arrf11={canfut11} onClose={closeasignar} 
              resinformacion={ResInfo} otherinfo={othInfo}/>
              
      <p className='establecimiento'>{NombreEstablecimiento}</p>
      <button className='newreserva' onClick={() => asignardatos('newreserva', '')}>Nueva reserva</button>
      <div className='day-selector-container'>
        <div className='Selectdias'>
              <div className='pre' onClick={diamenos}>
                  <p className='txtpre'>Dia antes</p>
              </div>
              <select id="select-dia" value={diaSeleccionado} onChange={manejarCambio}>
                  {diasdisponibles.map((dia, index) => (
                  <option key={index} value={dia}>
                      {dia}
                  </option>
                  ))}
                  <option hidden>{diaSeleccionado}</option>
              </select>
              <div className='post' onClick={diamas}>
                  <p className='txtpre'>Dia siguiente</p>
              </div>
          </div>
          <div className='calendar-icon-container'>
          <img src={Calendario} width="40px" onClick={() => {setOpenCal(!opencalendar), console.log(diaSeleccionadoISO)}}/></div>
          {opencalendar ? 
          (<div className='forcedate'>
            <DatePicker inline 
            selected={new Date(diaSeleccionadoISO + "T00:00:00")}
            onChange={(date) => {satedatepicker(date), console.log(diaSeleccionadoISO)}}
            minDate={new Date}
            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
            locale="es">
            </DatePicker>
          </div>) : null}
          </div>
              {isNaN(manejoHoras.apertura) ? (
            <div className='mensajefeliz'>
                <h1> El dia {diaSeleccionado.split(',')[0]} el establecimiento esta cerrado. </h1>
            </div>
          ) : (
            <div className='calendarioph'>
              <table className="calendario">
          <thead>
                <tr>
                    <th>Tipo</th>
                    {canfut5.length > 0 ? (<><th colSpan={canfut5.length}>FUT 5 </th></>):(<></>)}
                    {canfut7.length > 0 ? (<><th id="celdanegra"></th><th colSpan={canfut7.length}> FUT 7</th></>):(<></>)}
                    {canfut11.length > 0 ? (<><th id="celdanegra"></th><th colSpan={canfut11.length}> FUT 11</th></>):(<></>)}
                </tr>
                  <tr>
                      <th className='titnobold'>Hora </th>
                  {canfut5.map((cancha,index1)=>
                      <th className='titnobold' key={index1}>{cancha.nombre}</th>
                  )}
                  {canfut7.length > 0 ? (<><th id="celdanegra"></th></>):(<></>)}
                  {canfut7.map((cancha,index2)=>
                      <th className='titnobold' key={index2}>{cancha.nombre}</th>
                  )}
                  {canfut11.length > 0 ? (<><th id="celdanegra"></th></>):(<></>)}
                  {canfut11.map((cancha,index2)=>
                      <th className='titnobold' key={index2}>{cancha.nombre}</th>
                  )}
                  </tr>
              </thead>
              <tbody>
              {horas.map((hora, index3)=>
                <tr key={index3}> 
                  <td className={getClassName(null, hora, diaSeleccionadoISO)}
                  onClick={() => clickasignar(hora, diaSeleccionadoISO)}>
                    {hora}:00 - {Number(hora) + 1}:00</td>

                  {canfut5.map((cancha, i1) => ( //{canfut5.map((_, i) => ( <td key={`canfut5-${i}`}
                      <td key={i1} className={getClassName(cancha.id, hora, diaSeleccionadoISO)} 
                      onClick={() => clickDisponibilidad(cancha.id,hora, diaSeleccionadoISO, cancha.nombre, 5, cancha)}>
                        <p className='nombreencelda'>{NombreEnCelda(cancha.id,hora, diaSeleccionadoISO, cancha.nombre, 5)}</p>
                        </td>
                  ))}
                  {canfut7.length > 0 ? (<><th id="celdanegra"></th></>):(<></>)}
                  {canfut7.map((cancha,i2)=>(
                    <td key={i2} className={getClassName(cancha.id, hora, diaSeleccionadoISO)}
                    onClick={() => clickDisponibilidad(cancha.id, hora, diaSeleccionadoISO, cancha.nombre, 7, cancha)}
                    ><p className='nombreencelda'>{NombreEnCelda(cancha.id, hora, diaSeleccionadoISO, cancha.nombre, 7)}</p>
                    </td>
                  ))}
                  {canfut11.length > 0 ? (<><th id="celdanegra"></th></>):(<></>)}
                  {canfut11.map((cancha,i2)=>(
                    <td key={i2} className={getClassName(cancha.id, hora, diaSeleccionadoISO)}
                    onClick={() => clickDisponibilidad(cancha.id, hora, diaSeleccionadoISO, cancha.nombre, 11, cancha)}
                    ><p className='nombreencelda'>{NombreEnCelda(cancha.id, hora, diaSeleccionadoISO, cancha.nombre, 11)}</p>
                    </td>
                  ))}
                </tr>
             )}
             </tbody> 
          </table>
          <div className='coloresintrucciones'>
            <div className='celdaapp'>Creada por cliente</div><div className='celdatrigger'>Creada por relacion</div><div className='celdamanual'>Creada manualmente</div>
          </div>
            </div>
          )}
          </div>
          </>
          )}
  </div>
    );
  }

export default Inicio;

